import {
  InputGroupHelper,
  InputGroupHelperProps,
} from "@/ui/cva/input/InputGroupHelper";
import { useTranslation } from "next-i18next";
import { FieldError } from "react-hook-form";
import { ERROR_DONT_SHOW } from "@/common/static/form.static";

type InputGroupErrorHelperProps = {
  error?: Partial<FieldError>;
  errorValue?: Record<string, unknown>;
} & InputGroupHelperProps;

export const InputGroupErrorHelper = ({
  error,
  errorValue,
  valid: _valid,
  ...props
}: InputGroupErrorHelperProps) => {
  const { t } = useTranslation();

  /**
   * For some validation configurations (for example `required: true`),
   * error object does exist but the error message is simply an empty string.
   * That is why we are explicitly checking for existence of `error` object
   * and not just checkin `error?.message`.
   */
  const getMessage = () => {
    if (!error || error.message === ERROR_DONT_SHOW) {
      return;
    }

    if (error.message) {
      return t(error.message, errorValue);
    }

    return t("common:common-required");
  };

  const errorMessage = getMessage();

  if (!errorMessage) {
    return null;
  }

  return (
    <InputGroupHelper valid={false} {...props}>
      {errorMessage}
    </InputGroupHelper>
  );
};
